

<template>
<!--  Make sure parent is position: relative -->
    <div class="aup-saving-section-overlay w-100 h-100 d-flex justify-content-center align-items-center">
        <BaseBoxLoader/>
    </div>
</template>
<script>
export default {
    name: "BaseSavingOverlay"
};
</script>

<style lang="scss">
    .aup-saving-section-overlay {
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(255, 255, 255, 0.75);
        z-index: 5;
        &:parent {
            position: relative;
        }
    }
</style>

